module.exports = __webpack_public_path__ + "static/img/duxiu.476db5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/duxiu.png
// module id = NmsF
// module chunks = 3